export const PRODUCTS = {
  MAIL_SUITE: "MailSuite",
  SITE: "Site",
  DOMAIN: "NeoDomain",
};

export const PRODUCT_DISPLAY_NAMES = {
  [PRODUCTS.MAIL_SUITE]: "mail",
  [PRODUCTS.SITE]: "site",
  [PRODUCTS.DOMAIN]: "domain",
};

export const PRODUCT_TO_STATE_KEY_MAP = [
  { key: "mailSuiteDetails", product: PRODUCTS.MAIL_SUITE },
  { key: "siteDetails", product: PRODUCTS.SITE },
  { key: "domainDetails", product: PRODUCTS.DOMAIN },
];
